import CustomPageContainer from '@components/CustomPageContainer';
import {
  Divider, Row, Table, Tag,
} from 'antd';
import { TaggedAddButton, TaggedEditButton } from '@components/actionsButtons';
import { ColumnsType } from 'antd/es/table';
import { useState } from 'react';
import useModal from '@hooks/useModal';
import TaggedSwitch from '@components/switch/TaggedSwitch';
import { useGradingLimitsList, useThemeList } from '../src/gradingLimitsQueries';
import switchStyles from '../../../components/switch/styles.module.less';
import UpdateGradingLimitsModal from '../../../modalHouse/modals/gradingLimits/UpdateGradingLimitsModal';
import DeactivateGradingLimitsModal from '../../../modalHouse/modals/gradingLimits/DeactivateGradingLimitsModal';
import { useActivateGradingLimit } from '../src/gradingLimitsMutations';
import AddGradingLimitsModal from '../../../modalHouse/modals/gradingLimits/AddGradingLimitsModal';

const GradingLimitsList = () => {
  const { data: grades, isLoading: gradesLoading } = useGradingLimitsList();
  const { data: themes } = useThemeList();
  const { showModal: showUpdateGradingLimitModal, openModal: openUpdateGradingLimitModal, closeModal: closeUpdateGradingLimitModal } = useModal();
  const { showModal: showDeactivateGradingLimitModal, openModal: openDeactivateGradingLimitModal, closeModal: closeDeactivateGradingLimitModal } = useModal();
  const { showModal: showAddGradingLimitModal, openModal: openAddGradingLimitModal, closeModal: closeAddGradingLimitModal } = useModal();

  const [selectedGrade, setSelectedGrade] = useState<GradingLimits.GradingLimitsList>();

  const { mutate: activateGrade } = useActivateGradingLimit(selectedGrade!);

  const changeActivationSwitch = async (checked: boolean, record: GradingLimits.GradingLimitsList) => {
    await setSelectedGrade(record);

    if (checked) {
      activateGrade(record);
    } else {
      openDeactivateGradingLimitModal();
    }
  };

  const columns: ColumnsType<GradingLimits.GradingLimitsList> = [
    { title: 'ID', dataIndex: 'gradingId', align: 'center' },
    { title: 'Grade', dataIndex: 'grade', align: 'center' },
    { title: 'Suggested Absolute Limit', dataIndex: 'suggestedAbsoluteLimit', align: 'center' },
    { title: 'Suggested % Limit', dataIndex: 'suggestedLimitPercentage', align: 'center' },
    {
      title: 'Theme',
      dataIndex: 'suggestedThemeName',
      align: 'center',
      render: (value) => {
        return (
          <Tag key={value} color="green">
            {value}
          </Tag>
        );
      },
    },
    {
      title: 'Active',
      dataIndex: 'active',
      align: 'center',
      render: (active: string, record) => (
        <TaggedSwitch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          checked={active === '1'}
          className={switchStyles.customSwitch}
          tag="gradingStatus"
          onChange={(checked: boolean) => changeActivationSwitch(checked, record)}
        />
      ),
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      fixed: 'right',
      className: 'whitespace-nowrap',
      align: 'center',
      render: (value, record) => (
        <TaggedEditButton
          tooltiptext="Edit grading limit"
          tag="editGradingLimit"
          disabled={record.active !== '1'}
          onClick={() => {
            setSelectedGrade(record);
            openUpdateGradingLimitModal();
          }}
        />
      ),
    },
  ];

  return (
    <CustomPageContainer breadcrumbName="Grading Limits">
      <Row justify="end">
        <TaggedAddButton
          tag="addNewGrade"
          onClick={() => {
            openAddGradingLimitModal();
          }}
        >
          Add New Grade
        </TaggedAddButton>
      </Row>
      <Divider />
      <Table
        columns={columns}
        dataSource={grades}
        loading={gradesLoading}
        pagination={{ hideOnSinglePage: true }}
        rowClassName={(record, index) => (index % 2 === 0 ? 'dark-stripe' : '')}
      />
      {selectedGrade && (
        <UpdateGradingLimitsModal
          showModal={showUpdateGradingLimitModal}
          closeModal={closeUpdateGradingLimitModal}
          selectedGrade={selectedGrade}
          themes={themes!}
        />
      )}
      {selectedGrade && (
        <DeactivateGradingLimitsModal showModal={showDeactivateGradingLimitModal} closeModal={closeDeactivateGradingLimitModal} selectedGrade={selectedGrade} />
      )}
      <AddGradingLimitsModal showModal={showAddGradingLimitModal} closeModal={closeAddGradingLimitModal} themes={themes!} />
    </CustomPageContainer>
  );
};

export default GradingLimitsList;
